import { useMutation } from "@apollo/client/react";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import useCanStopScanRun from "shared/Scan/access/useCanStopScanRun";
import { ScanRunState } from "types/generated";

import { SCAN_RUN_STOP } from "./gql";

export type ScanRunForStop = {
  id: string;
  state: ScanRunState;
  scan: { space: { id: string } };
};

type UseStopScanRunOptions = {
  scanRun: ScanRunForStop;
  refetchQueries?: useMutation.Options["refetchQueries"];
};

const useStopScanRun = ({ scanRun, refetchQueries }: UseStopScanRunOptions) => {
  const { onError, reportSuccess } = useTypedContext(FlashContext);
  const canStop = useCanStopScanRun()(scanRun);

  const [stopScanRun, { loading: isStopping }] = useMutation(SCAN_RUN_STOP, {
    refetchQueries,
    awaitRefetchQueries: true,
  });

  const stop = (note?: string | null) =>
    stopScanRun({ variables: { id: scanRun.id, note: note || null } })
      .then(({ data }) => {
        if (data?.scanRunStop.id) {
          reportSuccess({ message: "Scan run successfully stopped" });
        }
      })
      .catch(onError);

  return {
    canStop,
    showStop: canStop.result || !!canStop.message,
    isStopping,
    stop,
  };
};

export default useStopScanRun;
